// src/modules/app-views/omnichannel/pages/Init/modals/TransferModal/index.jsx
// *******************************************************************************
// TRANSFER MODAL
// *******************************************************************************

// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { useMemo } from 'react';
import { SwapOutlined } from '@ant-design/icons';
import GenericModal from 'components/core/GenericModal';
import appService from 'services/appService';
import omnichannelService from '../../../../service';
import useZustand from 'hooks/useZustand';
import transferStep from './Step1';

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
const TransferModal = ({ show, setShow, afterClose, conversationId, onSuccess }) => {
  // ---------------------------------------------------------------------------
  // ZUSTAND
  // ---------------------------------------------------------------------------
  const storedSubscription = useZustand('auth', 'subscription');
  const storedUser = useZustand('auth', 'user');

  // ---------------------------------------------------------------------------
  // LOCAL VARIABLES
  // ---------------------------------------------------------------------------
  const teamMembers = storedSubscription?.team || [];
  const currentUserId = storedUser?._id;

  // ---------------------------------------------------------------------------
  // HANDLERS
  // ---------------------------------------------------------------------------
  const handleFinish = async ({ form }) => {
    try {
      const values = form.getFieldsValue(true);
      const { toAccountId, note } = values;

      await omnichannelService.transferConversation(conversationId, {
        toAccountId,
        note: note || undefined,
      });

      appService.message({ flag: 's', text: 'transfer_conversation_success' });
      onSuccess?.();
    } catch {
      return false;
    }
  };

  // ---------------------------------------------------------------------------
  // MEMOS
  // ---------------------------------------------------------------------------
  const steps = useMemo(
    () => [transferStep({ teamMembers, currentUserId })],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [teamMembers?.length, currentUserId],
  );

  // ---------------------------------------------------------------------------
  // UI
  // ---------------------------------------------------------------------------
  return (
    <GenericModal
      show={show}
      setShow={setShow}
      icon={<SwapOutlined />}
      title="transfer_conversation"
      steps={steps}
      onFinish={handleFinish}
      afterClose={afterClose}
      width={520}
    />
  );
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default TransferModal;
